export default function (address) {
    let addressText = ( address.suburb) + (address.state ? ', ' + address.state : '') + (address.postcode ? ' ' + address.postcode : '') + (address.country ? ', ' + address.country : '')
    return addressText;
}